import { splitInputByWhitespaceAndComma } from './utilityHelpers';

// Used to recoginze and validate a ComboID
export const NumericStringRegularExpression = /^[0-9]+$/;

export const GuidRegularExpression = new RegExp('^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$', 'i');

export const TemplateTokenRegularExpression = new RegExp('^(?:[csm]([0-9a-zA-Z-]+)(:v[0-9]+)?)\\.\\.[0-9a-zA-Z-]+$');

// Use this function for any user input that is reserved for Template Tokens only.
// Returns every valid template token in the input string
// Per RFC 5.2.1 all inputs must be validated using best practices
export function splitInputByWhitespaceOrCommaAndValidateTemplateTokens(input: string): string[] {
    return splitInputByWhitespaceAndComma(input)
        .filter((s) => !!s && s.match(TemplateTokenRegularExpression));
}
